var Reflux = require('@muzzylane/reflux'),
    ServerRequest = require('./request'),
    ErrorConsts = require('../constants/error'),
    ForgeError = require('../util/error');

var ResetPasswordActions = Reflux.createActions({
    "requestReset": {children: ["completed","failed"]},
    "resetPassword": {children: ["completed","failed"]}
});

ResetPasswordActions.requestReset.listen(function(actionID, params) {
    var self = this;

    if(!params.email){
        this.failed(actionID, new ForgeError({message: ErrorConsts.MISSING_PARAMS, uiRefs: ["email"]}));
        return;
    }

    ServerRequest.makeRequest('/authoring/request_password_reset', 'POST', JSON.stringify({
            email: params.email
        }))
        .then(function(res) {self.completed(actionID, res)})
        .catch(function(err) {self.failed(actionID, err)});
});

ResetPasswordActions.resetPassword.listen(function(actionID, params) {
    var self = this;
    var valid = true;
    var errorUIRefs = [];
    var errorMsg;

    if(!params.password){
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("password");
    }

    if(!params.passwordConfirm){
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("passwordConfirm");
    }

    if(valid && params.password !== params.passwordConfirm){
        valid = false;
        errorMsg = ErrorConsts.PASSWORD_MATCH;
        errorUIRefs.push("password", "passwordConfirm");
    }

    if(valid && (params.password.length < 8)){
        valid = false;
        errorMsg = ErrorConsts.PASSWORD_LENGTH;
        errorUIRefs.push("password", "passwordConfirm");
    }

    if(!valid){
        this.failed(actionID, new ForgeError({message: errorMsg, uiRefs: errorUIRefs}));
        return;
    }

    ServerRequest.makeRequest('/authoring/reset_password', 'POST', JSON.stringify({
            password: params.password,
            secret: params.secret
        }))
        .then(function(res) {self.completed(actionID, res)})
        .catch(function(err) {self.failed(actionID, err)});
});

module.exports = ResetPasswordActions;